import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { NEW_ADMIN_URL } from 'environment';

const IMAGE_PROPERTY_LIST = [
    'launch_image',
    'top_shelf_image_2x',
    'top_shelf_image',
    'top_shelf_wide_image_2x',
    'top_shelf_wide_image',
    'app_icon_background_layer',
    'app_icon_foreground_layer',
    'app_icon_small_background_layer_2x',
    'app_icon_small_background_layer',
    'app_icon_small_foreground_layer_2x',
    'app_icon_small_foreground_layer',
    'splash_screen_fhd',
    'splash_screen_hd',
    'splash_screen_sd',
    'channel_store_icon_fhd',
    'channel_store_icon_large',
    'channel_store_icon_small',
    'logo',
    'icon'
];

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/branded_apps', {
        template: require('./account_branded_apps.html'),
        controller: 'AccountBrandedAppsController'
    });
})
.controller('AccountBrandedAppsController', function($scope, $location, $q, $routeParams, $http, $timeout, $window, toaster, Account, AccountAppleTvApp, AccountRokuApp) {
    $scope.account = Account.get({ id: $routeParams.account_id });
    $scope.appleTvApps = AccountAppleTvApp.query({account_id: $routeParams.account_id});
    $scope.rokuApps = AccountRokuApp.query({account_id: $routeParams.account_id});
    $scope.$window = $window;
    $scope.toaster = toaster;
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.loading = true;
    $q.all([$scope.account.$promise, $scope.appleTvApps.$promise, $scope.rokuApps.$promise]).then(() => $scope.loading = false);

    $scope.setAppleDeveloperAccountName = app => {
        let newValue = $scope.$window.prompt("Enter Apple developer account name:", (app.apple_developer_account_name || ''));
        if (newValue != null) {
            AccountAppleTvApp.update(
                {id: app.id, account_id: app.account_id, apple_developer_account_name: newValue},
                updatedApp => app.apple_developer_account_name = updatedApp.apple_developer_account_name,
                err => {
                    console.error(err);
                    $scope.toaster.pop({
                        type: 'error',
                        body: `Error updating Apple developer account name. Please try again.`,
                        timeout: 2000
                    });
                }
            );
        }
    };
    $scope.setRokuDeveloperAccountName = app => {
        let newValue = $scope.$window.prompt("Enter Roku developer account name:", (app.roku_developer_account_name || ''));
        if (newValue != null) {
            AccountRokuApp.update(
                {id: app.id, account_id: app.account_id, roku_developer_account_name: newValue},
                updatedApp => app.roku_developer_account_name = updatedApp.roku_developer_account_name,
                err => {
                    console.error(err);
                    $scope.toaster.pop({
                        type: 'error',
                        body: `Error updating Roku developer account name. Please try again.`,
                        timeout: 2000
                    });
                }
            );
        }
    };

    const resourceForApp = app => (app.hasOwnProperty('apple_developer_account_name') ? AccountAppleTvApp : AccountRokuApp);

    $scope.setStatus = (app, newStatus) => {
        resourceForApp(app).update(
            {id: app.id, account_id: app.account_id, status: newStatus},
            updatedApp => app.status = updatedApp.status,
            err => {
                console.error(err);
                $scope.toaster.pop({
                    type: 'error',
                    body: `Error updating app status. Please try again.`,
                    timeout: 2000
                });
            }
        );
    };

    $scope.remove = app => {
        if ($scope.$window.confirm("Are you sure you wish to remove this app?")) {
            $scope.setStatus(app, 'removed');
        }
    };

    const isImageProperty = propertyName => _.contains(IMAGE_PROPERTY_LIST, propertyName);

    $scope.downloadBundle = app => {
        // Helper function for errors below; captures `app` in closure.
        const alertError = (whatWasHappening, err) => {
            // Gratuitously wrapping in $timeout so this can be used in or out of a digest-aware place
            $timeout(() => {
                console.error(err);
                $scope.toaster.pop({
                    type: 'error',
                    body: `Error ${whatWasHappening}. Please try again.`,
                    timeout: 2000
                });
                delete app._downloading;
            });
        };

        app._downloading = true;
        // First, go get the app
        resourceForApp(app).get(
            {id: app.id, account_id: app.account_id},
            appShow => {
                const zip = new JSZip();
                const folder = zip.folder(appShow.id);

                // Start with just a pretty-print JSON dump of the app resource itself
                folder.file(`${appShow.id}.json`, JSON.stringify(appShow, null, '\t'));

                // Fetch all the image files
                const imagePromises = [];
                for (const [key, value] of Object.entries(appShow)) {
                    if (isImageProperty(key) && value) {
                        imagePromises.push(
                            $http.get(value, {responseType: 'arraybuffer'}).then(resp => {
                                const extension = (resp.headers("content-type") == 'image/png' ? '.png' : '.jpg');
                                folder.file(`${key}${extension}`, resp.data, {binary: true});
                            })
                        );
                    }
                }
                $q.all(imagePromises).then(() => {
                    zip.generateAsync({type:"blob"}).then(content => {
                        saveAs(content, `${appShow.id}.zip`);
                        $timeout(() => delete app._downloading);
                    }).catch(err => alertError('downloading app bundle', err));
                }).catch(err => alertError('downloading app images', err));
            },
            err => alertError('getting app', err)
        );
    };
});


// WEBPACK FOOTER //
// ./views/account/account_branded_apps_controller.js